// extracted by mini-css-extract-plugin
export var badgeWrapper = "index-module--badge-wrapper--7+Dw0";
export var root = "index-module--root--gNfSc";